import { render } from "./OapBeautyGeniusCard.vue?vue&type=template&id=615f4229"
import script from "./OapBeautyGeniusCard.vue?vue&type=script&lang=js"
export * from "./OapBeautyGeniusCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__